import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Navbar - Dynamic navigation menu based on user authentication and role
 *
 * - Public users: Home, FAQ
 * - Logged in regular users: Scrumboard, Planning
 * - Logged in admins: Dashboard
 */
function Navbar() {
  const { isLoggedIn, isAdmin } = useAuth();

  // Handle ctrl+click or shift+click to open in new tab
  const handleClick = (e) => {
    if (e.ctrlKey || e.shiftKey) {
      const url = e.currentTarget.getAttribute('href');
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
      e.preventDefault();
    }
  };

  return (
    <ul className="nav navbar-nav" id="navbar">
      {/* Public links - shown when not logged in */}
      {!isLoggedIn && (
        <>
          <li>
            <Link to="/" className="internal-link" onClick={handleClick}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/faq" className="internal-link" onClick={handleClick}>
              FAQ
            </Link>
          </li>
        </>
      )}

      {/* Links for all logged-in users */}
      {isLoggedIn && (
        <>
          <li>
            <Link to="/scrumboard" className="internal-link" onClick={handleClick}>
              Scrumboard
            </Link>
          </li>
          <li>
            <Link to="/sprints" className="internal-link" onClick={handleClick}>
              Sprints
            </Link>
          </li>
          <li>
            <Link to="/planning" className="internal-link" onClick={handleClick}>
              Planning
            </Link>
          </li>
        </>
      )}

      {/* Admin-only links */}
      {isLoggedIn && isAdmin && (
        <li id="dashboard-link">
          <Link to="/dashboard" className="internal-link" onClick={handleClick}>
            Dashboard
          </Link>
        </li>
      )}
    </ul>
  );
}

export default Navbar;
